

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import axioss from 'axios'
import VueJsonp from 'vue-jsonp'
import wx from 'weixin-js-sdk';
import '../static/css/font-awesome.css'
import '../static/css/iconfont.css'
import '../static/css/common.css'
import '../static/css/animate.min.css'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import Qs from 'qs';
import VueScroller from 'vue-scroller'
const FastClick = require('fastclick')
FastClick.attach(document.body)







Vue.prototype.qs = Qs
Vue.prototype.$https = axioss


Vue.prototype.BASE_URL = process.env.BASE_URL  
Vue.prototype.wechat_url = process.env.WECHAT_URL   
Vue.prototype.appjump_url = process.env.APPJUMP_URL   
Vue.prototype.QKL_URL = process.env.QKL_URL 
Vue.prototype.wechatAppid = process.env.WECHATAPPID    
Vue.prototype.DT_QKL = process.env.DT_QKL 
Vue.prototype.zc_userhead = process.env.ZC_USERHEAD 
Vue.prototype.zc_userhead_act = process.env.ZC_USERHEAD_ACT 
Vue.prototype.mchTypeH5 = process.env.MCHTYPEH5  
Vue.prototype.cmsApp_Url = process.env.CMSAPP_URL     
Vue.prototype.cmsnewsId = process.env.CMSNEWSID     
Vue.prototype.cmsnewsIdQZ = process.env.CMSNEWSID_QZ     
Vue.prototype.cmsnewsIdBNZ = process.env.CMSNEWSID_BNZ     
Vue.prototype.wx_maidianId = process.env.WXMDID     
Vue.prototype.cms_1017act = process.env.CMS_1017ACT      
Vue.prototype.BF_PAY_URL = process.env.BF_PAY_URL
Vue.prototype.XFFP_URL = process.env.XFFP_URL    
Vue.prototype.CCY_URL = process.env.CCY_URL







Vue.component('flexbox', Flexbox)
Vue.component('flexbox-item', FlexboxItem)
Vue.use(VueJsonp)


Vue.use(ToastPlugin)
Vue.use(VueScroller)
Vue.use(wx)

Vue.prototype.showToast = function (showPositionValue, type, text, width = '20em', position = 'bottom') {
this.$vux.toast.show({
showPositionValue: false,
text: text,
type: type,
width: width,
position: position,
showBackArrow: true
})
}

Vue.prototype.isWeixinCient = function () {
let ua = window.navigator.userAgent.toLowerCase()
if (ua.match(/MicroMessenger/i) == 'micromessenger') {
return true
} else {
return false
}
}
Vue.prototype.L = function (a, b) {
localStorage.setItem(a, b)
}
Vue.prototype.G = function (a) {
return localStorage.getItem(a)
}



window.appRedirectUrl = (reurl)=>{
window.location.href = reurl
}




Vue.prototype.changeURLPar = function(destiny, par, par_value){
var pattern = par+'=([^&]*)';
var replaceText = par+'='+par_value;
if (destiny.match(pattern)){
var tmp = '/\\'+par+'=[^&]*/';
if(par=='token'){
tmp = destiny.replace(par+'=', replaceText);
}else{
tmp = destiny.replace(eval(tmp), replaceText);
}
return (tmp);
}else{
if (destiny.match('[\?]')){
return destiny+'&'+ replaceText;
}else{
return destiny+'?'+replaceText;
}
}
return destiny+'\n'+par+'\n'+par_value;
}

Vue.prototype.setWeixinConfig = function (obj) {
let self = this;
let url = window.location.href.split("#")[0];
this.$https.post(this.BASE_URL+'uts/wechat/makeWXTicket',this.qs.stringify({'url':url}),{
headers:{
'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'
}
}).then( data => {
wx.config({
debug: false, ////生产环境需要关闭debug模式
appId: data.data.data.appid, //appId通过微信服务号后台查看
timestamp: data.data.data.timestamp, //生成签名的时间戳
nonceStr: data.data.data.nonceStr, //生成签名的随机字符串
signature: data.data.data.signature, //签名
jsApiList: ['checkJsApi', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'chooseImage']
});
console.log(data.data.data)
wx.ready(function () {
wx.onMenuShareTimeline(obj);
wx.onMenuShareAppMessage(obj);
wx.onMenuShareWeibo(obj);
wx.onMenuShareQQ(obj);

})
})
}
new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js